import React, {useContext, useState} from 'react';
import {
    Avatar,
    Box,
    Button,
    Card,
    CardContent,
    CircularProgress,
    InputAdornment,
    TextField,
    Typography
} from "@mui/material";
import {
    BadgeRounded,
    PersonOutlineRounded,
    PhoneIphoneRounded,
    SaveRounded
} from "@mui/icons-material";
import {ErrorContext} from "../../../components/GympinPagesProvider";
import {user_update} from "../../../network/api/user.api";

const _UserBaseData = ({corporatePersonnel, getCorporatePerson}) => {
    const error = useContext(ErrorContext);
    const [values, setValues] = useState(corporatePersonnel.User || {});
    const [submitting, setSubmitting] = useState(false);

    const handleChange = (name) => (event) => {
        setValues({...values, [name]: event.target.value});
    };

    function ChangeUserBaseData(e) {
        e.preventDefault();
        setSubmitting(true);
        user_update(values).then(() => {
            setSubmitting(false);
            error.showError({message: "اطلاعات کارمند با موفقیت ذخیره شد"});
            if (getCorporatePerson) getCorporatePerson();
        }).catch(e => {
            setSubmitting(false);
            try {
                error.showError({message: e.response?.data?.Message || "خطا در بروزرسانی اطلاعات"});
            } catch (f) {
                error.showError({message: "خطای نامشخص"});
            }
        });
    }

    const user = corporatePersonnel.User;
    if (!user) return null;

    return (
        <Card
            elevation={0}
            sx={{
                borderRadius: 4,
                border: '1px solid',
                borderColor: 'divider',
                bgcolor: 'background.paper',
                boxShadow: '0 2px 14px rgba(0, 0, 0, 0.03)',
                overflow: 'hidden'
            }}
        >
            <Box
                sx={{
                    p: 2,
                    px: 2.5,
                    borderBottom: '1px solid',
                    borderColor: 'divider',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1.2,
                    bgcolor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.02)' : 'rgba(0, 0, 0, 0.015)'
                }}
            >
                <PersonOutlineRounded sx={{ color: 'primary.main', fontSize: 20 }} />
                <Typography variant="subtitle1" sx={{ fontWeight: 800 }}>
                    مشخصات هویتی پرسنل
                </Typography>
            </Box>

            <CardContent sx={{ p: 2.5 }}>
                <Box
                    component="form"
                    noValidate
                    autoComplete="off"
                    onSubmit={ChangeUserBaseData}
                    sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}
                >
                    <TextField
                        label="شماره تلفن همراه"
                        value={values.PhoneNumber || ""}
                        disabled
                        margin="none"
                        variant="outlined"
                        fullWidth
                        dir="ltr"
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <PhoneIphoneRounded sx={{ color: 'text.secondary', fontSize: 20 }} />
                                </InputAdornment>
                            ),
                            sx: { borderRadius: 2.5 }
                        }}
                        helperText="شماره همراه شناسه ثابت حساب کارمند است"
                    />

                    <TextField
                        label="نام و نام خانوادگی"
                        value={values.FullName || ""}
                        onChange={handleChange("FullName")}
                        margin="none"
                        variant="outlined"
                        fullWidth
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <BadgeRounded sx={{ color: 'text.secondary', fontSize: 20 }} />
                                </InputAdornment>
                            ),
                            sx: { borderRadius: 2.5 }
                        }}
                    />

                    <Button
                        variant="contained"
                        type="submit"
                        disabled={submitting}
                        startIcon={submitting ? null : <SaveRounded sx={{ ml: 1, mr: -0.5 }} />}
                        sx={{
                            mt: 1,
                            borderRadius: 2.5,
                            py: 1.1,
                            fontWeight: 700,
                            boxShadow: '0 4px 14px rgba(28, 139, 156, 0.25)'
                        }}
                    >
                        {submitting ? <CircularProgress size={22} color="inherit" /> : "ذخیره تغییرات"}
                    </Button>
                </Box>
            </CardContent>
        </Card>
    );
};

export default _UserBaseData;

